/**
 * Creates a dynamic URL based on the current URL in the address bar.
 *
 * @param path
 */
export function makeEndpointUrl(path: string): string {
    return `${window.location.protocol}//${window.location.hostname}${path}`;
}
